module.exports = __webpack_public_path__ + "static/ForTheKing2-8f29c6b503eb471eac2371075ad16f15.png";